<script setup lang="ts">
import type { UserRole } from '@apparatix/schemas/Owner';
import { AppStore } from '@apparatix/stores/AppStore';

type Props = {
  allowFor: UserRole[],
};

const props = defineProps<Props>();
</script>
<template>
  <slot v-if="AppStore.currentUser.roles?.some(role => props.allowFor.includes(role as UserRole))" />
  <slot v-else name="fallback" />
</template>
